import { FilePdfIcon } from "@phosphor-icons/react/dist/csr/FilePdf";
import { ArrowCounterClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowCounterClockwise";
import { ArrowsHorizontalIcon } from "@phosphor-icons/react/dist/csr/ArrowsHorizontal";
import { ChartLineIcon } from "@phosphor-icons/react/dist/csr/ChartLine";
import { CubeIcon } from "@phosphor-icons/react/dist/csr/Cube";
import { GearSixIcon } from "@phosphor-icons/react/dist/csr/GearSix";
import { ListNumbersIcon } from "@phosphor-icons/react/dist/csr/ListNumbers";
import { PauseIcon } from "@phosphor-icons/react/dist/csr/Pause";
import { PlayIcon } from "@phosphor-icons/react/dist/csr/Play";

export type ViewerIconName = "pdf" | "settings" | "hypnogram" | "width" | "order" | "orientation" | "Play" | "Pause" | "Resume" | "Replay";
const ICONS = {
  pdf: FilePdfIcon,
  settings: GearSixIcon,
  hypnogram: ChartLineIcon,
  width: ArrowsHorizontalIcon,
  order: ListNumbersIcon,
  orientation: CubeIcon,
  Play: PlayIcon,
  Pause: PauseIcon,
  Resume: PlayIcon,
  Replay: ArrowCounterClockwiseIcon,
};

export function ViewerIcon({name}:{name:ViewerIconName}) {
  const Icon = ICONS[name];
  return <Icon aria-hidden="true" focusable="false" size={22} color="currentColor" weight="regular" />;
}
